<template>
	<div class="card skeleton">
		<div class="card-body pt-1">
			<div class="skeleton-block h-3 w-80 mb-2"></div>
			<div class="skeleton-block h-3 w-90 mb-2"></div>
			<div class="skeleton-block h-3 w-80 mb-2"></div>
			<div class="skeleton-block h-3 w-70 mb-2"></div>
		</div>
		<div class="card-body border-top">
			<div class="skeleton-block h-4 mt-2 w-100 mb-4"></div>
			<div class="row gx-2">
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
			</div>
		</div>
		<div class="card-body border-top">
			<div class="skeleton-block h-4 w-100 mt-2 mb-2"></div>
			<div class="skeleton-block h-4 w-100 mb-4"></div>
			<div class="skeleton-block h-4 w-100 mt-3 mb-4"></div>
		</div>
		<div class="card-body border-top">
			<div class="skeleton-block h-4 w-100 mt-2 mb-2"></div>
			<div class="skeleton-block h-3 w-70 mb-4"></div>
			<div class="row gx-2">
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
			</div>
			<div class="skeleton-block h-4 w-100 mt-3 mb-4"></div>
			<div class="row gx-2">
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
			</div>
		</div>
		<div class="card-body border-top">
			<div class="row g-2 mt-2">
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
			</div>
			<div class="row g-2">
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-2"></div>
				</div>
			</div>
			<div class="row g-2">
				<div class="col">
					<div class="skeleton-block h-4 w-100 mb-3"></div>
				</div>
				<div class="col"></div>
				<div class="col"></div>
				<div class="col"></div>
				<div class="col"></div>
			</div>
			<div class="skeleton-block h-3 w-70 mb-2"></div>
		</div>
		<div class="card-body border-top">
			<div class="skeleton-block h-4 mt-2 w-100 mb-3"></div>
			<div class="skeleton-block h-3 w-70 mb-2"></div>
			<div class="skeleton-block h-3 w-90 mb-2"></div>
			<div class="skeleton-block h-3 w-80 mb-2"></div>
			<div class="skeleton-block h-3 w-50 mb-2"></div>
			<div class="skeleton-block h-3 w-60 mb-2"></div>
			<div class="skeleton-block h-3 w-80 mb-2"></div>
			<div class="skeleton-block h-3 w-70 mb-2"></div>
			<div class="skeleton-block h-3 w-80 mb-2"></div>
			<div class="skeleton-block h-3 w-70 mb-2"></div>
			<div class="skeleton-block h-3 w-80 mb-2"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ListFilterSkeleton',
}
</script>

<style scoped></style>
